import React from "react";
import {
  getFontFamily,
  getFontSize,
  getTextColor,
} from "../../../service/ui/UI";
import UtilityHelper from "../../../service/utilities/UtilityHelper";

const fontNameClass = (
  fontName: string = "",
  fontSize: string = "",
  textColor: string = ""
): string => {
  let classes: Array<string> = [];
  const fontNameClass = getFontFamily(
    UtilityHelper.isNotEmpty(fontName) ? fontName : "Book"
  );
  const fontSizeClass = getFontSize(fontSize);
  const textColorClass = getTextColor(
    UtilityHelper.isNotEmpty(textColor) ? textColor : "white"
  );

  if (UtilityHelper.isNotEmpty(fontNameClass)) {
    classes.push(fontNameClass);
  }
  if (UtilityHelper.isNotEmpty(fontSizeClass)) {
    classes.push(fontSizeClass);
  }
  if (UtilityHelper.isNotEmpty(textColorClass)) {
    classes.push(textColorClass);
  }
  return classes.join(" ");
};

export const BadgeCircle: React.FC<{
  bgColor?: string;
  color?: string;
  fontName?: string;
  fontSize?: string;
  counter?: number;
  showZero?: boolean;
}> = ({
  bgColor = "",
  color,
  fontName,
  fontSize,
  showZero = false,
  counter = 0,
}) => {
  const classes: string = fontNameClass(fontName, fontSize, color);
  bgColor = UtilityHelper.isEmpty(bgColor)
    ? "bgcolor-black"
    : `bgcolor-${bgColor}`;

  const renderHtml = (value: number = 0) => {
    return (
      <div className={`theme-badge font-size-9 ${classes} ${bgColor}`}>
        {value > 99 ? `99+` : value}
      </div>
    );
  };

  return (
    <>
      {showZero ? (
        renderHtml(counter)
      ) : counter > 0 ? (
        renderHtml(counter)
      ) : (
        <></>
      )}
    </>
  );
};
